<template>
    <div class="container-fluid">
        <nav>
            <ol class="breadcrumb">
                <li class="breadcrumb-item"><router-link to="/mypage">マイページ</router-link></li>
                <li class="breadcrumb-item">フォロー</li>
            </ol>
        </nav>
        <div class="container">
            <div v-if="followees.total">
                <div class="sticky">
                    <page :last_page="followees.last_page" v-model="page" @goto="goto"></page>
                </div>
                <div class="row pb-4" v-for="f in followees.data" :key="f.id">
                    <div class="col-xl profile-column" v-if="f.profile_url">
                        <a :href="authorUrl(f)">
                            <img :src="f.profile_url + '?' + f.profile_hash" class="img-fluid img-thumbnail mx-auto d-block profile" />
                        </a>
                    </div>
                    <div class="col-xl p-3">
                        <h4>
                            <div class="row">
                                <div class="col-xl-9 mincho">
                                    <a :href="authorUrl(f)">
                                        <ruby>{{f.name}}<rt>{{f.kana}}</rt></ruby>
                                    </a>
                                </div>
                                <div class="col-xl-3 text-right">
                                    <button type="button" class="btn btn-outline-secondary"
                                        @click="unfollowAuthor(f.id)">
                                        <i class="fas fa-heart-broken"></i>
                                        フォローを外す
                                    </button>
                                </div>
                            </div>
                        </h4>
                        <div class="ul py-2" v-html="$filters.wrap(f.profile)"></div>
                        <div class="pt-2">
                            書籍数: {{f.books_count}} 冊
                        </div>
                    </div>
                </div>
            </div>
            <div class="nothing" v-else>
                フォローしている作家さんはいません。
            </div>
        </div>
    </div>
</template>

<style scoped>
.profile {
    width: 250px;
    height: 250px;
    object-fit: cover;
}
.profile-column {
    max-width: 280px;
}
@media screen and (max-width: 1200px) {
    .profile-column {
        max-width: none;
    }
}
</style>

<script>
import page from "components/Page";
export default {
    components: {
        page
    },
    data() {
        return {
            followees: [],
            page: this.$route.query?.page || 1,
        }
    },
    methods: {
        goto(p) {
            this.page = p;
            this.$router.push("/mypage/followees?page=" + p);
            setTimeout(() => {this.load();});
        },
        load() {
            $("html,body").animate({scrollTop: 0}, 300);
            axios.get("/mypage/followees/get", {params: {page: this.page}}).then(res => {
                this.followees = res.data;
            }).catch(err => {alert.err(err.response)});
        },
        unfollowAuthor(id) {
            axios.post("/mypage/followee/unfollow", {id: id}).then(res => {
                alert.msg(res.data);
                this.load();
            }).catch(err => {
                alert.err(err.response);
            });
        },
        authorUrl(f) {
            return "//" + f.subdomain + this.$store.state.base_domain + "/";
        }
    },
    mounted() {
        this.load();
        setTimeout(() => {
            this.useHead({
                title: "フォロー | 貸し本棚",
                link: [ { rel: "canonical", href: location.origin + location.pathname, id: "canonical" } ],
                meta: [
                    { name: "keywords", content: "貸し本棚,小説投稿,Web小説,小説展示,オンライン小説,縦書き小説,置き場,文芸,ライトノベル", id: "meta-keywords" },
                    { name: "description", content: "小説を書くこと、読むことにフォーカスした小説投稿サイトです。作家さん独自のサブドメインで、ご自身の小説を公開できます。横断的に編集ができるエディタで原稿執筆することも、過去の作品をレーティングを気にせず展示することもできます。", id: "meta-description" }
                ]
            });
        }, 1000);
    }
}
</script>